import ProfileScreen from '../../../src/screens/ProfileScreen';

export default function ProfileTab() {
  return <ProfileScreen />;
}
